<template>
  <div class="container is-fluid container-margin-top">
    <div class="content content-padding">
      <h1>Menus Associados ao Coche</h1>

      <div v-if="isDataLoaded" v-for="category in coachCategories">
        <div class="title-with-selector h3-selector">
          <h3 class="subtitle"><b>{{category.languages[0].pivot.name}}</b></h3>
          <state-selector :selected="category ? parseInt(category.state_id) : null" 
                          :target="category"
                          :update="'menu'" 
          ></state-selector>
        </div>
        <!-- <h4 class="subtitle"><b>{{category.languages[0].pivot.name}}</b></h4> -->

        <div class="columns" v-if="category.slug !== 'panorama'">
          <div class="column is-one-quarter">
            <div>
              <b>Cor de Fundo</b><br/>
              <div class="flex-container-center">
                {{category.background_color}}
                <div class="color-preview" v-bind:style="{ backgroundColor: category.background_color }"></div>
              </div>
            </div>
          </div>
          <div class="column is-one-quarter" v-if="category.slug !== 'eraumavez'">
            <div>
              <b>Cor Caixa de Texto</b><br/>
              <div class="flex-container-center">
                {{category.textbox_color}}
                <div class="color-preview" v-bind:style="{ backgroundColor: category.textbox_color }"></div>
              </div>
            </div>
          </div>
          <div class="column is-one-quarter">
            <div>
              <b>Cor do Texto</b><br/>
              <div class="flex-container-center">
                {{category.text_color}}
                <div class="color-preview" v-bind:style="{ backgroundColor: category.text_color }"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="columns is-multiline" v-if="category.slug !== 'panorama'">
          <div class="column is-12" v-if="category.background_path_1">
            <span><b>Background 1</b></span>
            <figure class="image coach-image">
              <img :src="imagePath + category.background_path_1">
            </figure>
          </div>
          <div class="column is-12" v-if="category.background_path_2">
            <span><b>Background 2</b></span>
            <figure class="image coach-image">
              <img :src="imagePath + category.background_path_2">
            </figure>
          </div>
        </div>

        <div class="columns" v-if="category.slug === 'panorama'">
          <div class="column is-one-quarter">
            <!-- Panorama -->
          </div>
        </div>

        <a class="button is-small is-info" v-if="category.slug !== 'panorama'" @click="goToSlide(category.id)">
          <span class="icon is-small">
            <i class="fa fa-external-link"></i>
          </span>
          <span>Slides</span>
        </a>
        <a class="button is-small is-info" v-if="category.slug === 'panorama'" @click="goToPanorama()">
          <span class="icon is-small">
            <i class="fa fa-external-link"></i>
          </span>
          <span>Panorama</span>
        </a>
        <a class="button is-small is-info" v-if="category.slug === 'panorama'" @click="goToExterior()">
          <span class="icon is-small">
            <i class="fa fa-external-link"></i>
          </span>
          <span>Exterior</span>
        </a>
        <a class="button is-small is-primary" @click="editCoachEditCategoryModal(category)" v-if="category.slug !== 'panorama'">
          <span class="icon is-small">
            <i class="fa fa-edit"></i>
          </span>
          <span>Editar</span>
        </a>
        <a class="button is-small is-danger" @click="removeCoachDeleteCategoryModal(category)">
          <span class="icon is-small">
            <i class="fa fa-trash"></i>
          </span>
          <span>Apagar</span>
        </a>

        <hr>
      </div>

      <div v-if="slideCategories ? slideCategories.length : null">
        <label class="label">Adicionar Menu ao Coche</label>
        <p class="control">
          <span class="select">
            <select v-model="selectedCategory">
              <option v-for="category in slideCategories" :value="parseInt(category.id)">{{category.languages[0].pivot.name}}</option>
            </select>
          </span>

          <a class="button is-primary" @click="addCoachEditCategoryModal" :class="{ 'is-disabled' : !selectedCategorySlug }">
            <span class="icon">
              <i class="fa fa-plus"></i>
            </span>
            <span>Adicionar</span>
          </a>
        </p>
      </div>

    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import CoachEditCategoryModal from './CoachEditCategoryModal'
  import CoachDeleteCategoryModal from './CoachDeleteCategoryModal'
  import StateSelector from '../Util/StateSelector'
  import { WHITE_COLOR, BACKGROUND_IMG_PATH } from '../../config'

  const CoachEditCategoryModalComponent = Vue.extend(CoachEditCategoryModal)
  const CoachDeleteCategoryModalComponent = Vue.extend(CoachDeleteCategoryModal)

  export default {
    components: {
      StateSelector
    },

    data () {
      return {
        coachId: this.$store.state.route.params.id,
        selectedCategory: null,
        imagePath: BACKGROUND_IMG_PATH,
        isDataLoaded: false
      }
    },

    mounted () {
      this.getCategoryData()
    },

    computed: {
      currentEvent () {
        return window.store.state.event.nextEvent
      },

      slideCategories () {
        return this.$store.state.coach.slideCategories
      },

      coachCategories () {
        return this.$store.state.coach.coachCategories
      },

      selectedCategoryText () {
        if (this.selectedCategory) {
          for (let category of this.slideCategories) {
            if (parseInt(category.id) === this.selectedCategory) {
              return category.languages[0].pivot.name
            }
          }
        }
        return null
      },

      selectedCategorySlug () {
        if (this.selectedCategory) {
          for (let category of this.slideCategories) {
            if (parseInt(category.id) === this.selectedCategory) {
              return category.slug
            }
          }
        }
        return null
      }
    },

    methods: {
      getCategoryData () {
        this.$store.dispatch('getCategoryList', this.coachId)
      },

      goToSlide (slide) {
        let route = this.coachId + '/menu/' + slide
        window.router.push(route)
      },

      goToExterior () {
        let route = this.coachId + '/exterior'
        window.router.push(route)
      },
      goToPanorama () {
        let route = this.coachId + '/panorama'
        window.router.push(route)
      },

      addCoachEditCategoryModal () {
        if (this.selectedCategorySlug !== 'panorama') {
          let openCardModal = (propsData = {}) => {
            return new CoachEditCategoryModalComponent({
              el: document.createElement('div'),
              propsData
            })
          }

          openCardModal({
            title: 'Adicionar - ' + this.selectedCategoryText,
            category_id: this.selectedCategory,
            coach_id: parseInt(this.coachId)
          })
        } else {
          let category = {
            slide_category_id: this.selectedCategory,
            coach_id: parseInt(this.coachId),
            background_color: WHITE_COLOR,
            textbox_color: WHITE_COLOR,
            text_color: WHITE_COLOR,
            background_image_1: null,
            background_image_2: null,
            background_path_1: null,
            background_path_2: null
          }
          this.$store.dispatch('categoryCoach', category)
        }
      },

      editCoachEditCategoryModal (category) {
        let openCardModal = (propsData = {}) => {
          return new CoachEditCategoryModalComponent({
            el: document.createElement('div'),
            propsData
          })
        }

        openCardModal({
          title: 'Editar - ' + category.languages[0].pivot.name,
          category_id: parseInt(category.slide_category_id),
          coach_id: parseInt(this.coachId),
          categoryData: category
        })
      },

      removeCoachDeleteCategoryModal (category) {
        let openCardModal = (propsData = {}) => {
          return new CoachDeleteCategoryModalComponent({
            el: document.createElement('div'),
            propsData
          })
        }

        openCardModal({
          title: 'Remover Menu?',
          category_id: parseInt(category.slide_category_id),
          coach_id: parseInt(this.coachId)
        })
      }
    },

    watch: {
      currentEvent: function (val) {
      },

      coachCategories: function (val) {
        if (val) {
          this.isDataLoaded = true
        }
      }
    }
  }
</script>

<style lang="scss">
  .title-with-selector {
    display: flex;
  }

  .h3-selector .state-selector {
    margin-top: 0;
    margin-left: 5px;
  }
</style>


// WEBPACK FOOTER //
// CoachCategories.vue?fab0509e